(function () {
  "use strict";

  var config = window.__SS_POSTHOG_CONFIG__ || {};
  var cookieName = "ss_ph_cid";
  var allowedEvents = new Set([
    "page_viewed", "product_viewed", "configurator_opened", "configuration_changed",
    "configurator_validation_error", "product_added_to_cart"
  ]);
  var allowedProperties = new Set([
    "product_id", "variant_id", "price", "currency", "quantity", "category",
    "configuration_category", "error_code", "page_type", "path_class", "replay_sampled"
  ]);
  var configuratorSelectors = ["[data-cfg-root]", "[data-configurator]", ".cfg-app", ".cfg-preview", "#cfg-root"].join(",");
  var blockedSelectors = [
    "form[action*='/checkout']", "[data-checkout]", ".checkout", "[data-payment]", ".payment",
    "[autocomplete^='cc-']", "iframe[src*='checkout']", "iframe[src*='payment']", "input[type='password']"
  ].join(",");
  var started = false;
  var loading = false;
  var openingSent = false;
  var bound = false;
  var avadaWatching = false;
  var changeTimer = null;
  var consentGeneration = 0;
  var activePrivacy = null;

  function analyticsAllowed(privacy) {
    try { return Boolean(privacy && privacy.analyticsProcessingAllowed() === true); } catch (_) { return false; }
  }

  function bridgeId() {
    var prefix = cookieName + "=";
    var value = document.cookie.split(";").map(function (part) { return part.trim(); })
      .filter(function (part) { return part.indexOf(prefix) === 0; })
      .map(function (part) { return decodeURIComponent(part.slice(prefix.length)); })[0] || "";
    return /^[A-Za-z0-9._:-]{8,160}$/.test(value) ? value : "";
  }

  function safePathClass() {
    var path = location.pathname || "/";
    if (/^\/products\//.test(path)) return "product";
    if (/^\/collections\//.test(path)) return "collection";
    if (/^\/cart\/?$/.test(path)) return "cart";
    if (/^\/account(?:\/|$)/.test(path)) return "account";
    if (/^\/pages\/contact\/?$/.test(path)) return "contact";
    if (/^\/checkouts?(?:\/|$)/.test(path)) return "checkout";
    return path === "/" ? "home" : "other";
  }

  function sanitize(properties) {
    properties = properties || {};
    var output = { $geoip_disable: true, $ip: null };
    Object.keys(properties).forEach(function (key) {
      if (allowedProperties.has(key) && ["string", "number", "boolean"].indexOf(typeof properties[key]) !== -1) {
        output[key] = properties[key];
      }
    });
    if (typeof properties.distinct_id === "string" && /^shopify:[A-Za-z0-9._:-]{8,180}$/.test(properties.distinct_id)) output.distinct_id = properties.distinct_id;
    ["$session_id", "$window_id"].forEach(function (key) {
      if (typeof properties[key] === "string" && /^[0-9a-f-]{32,40}$/i.test(properties[key])) output[key] = properties[key];
    });
    if (typeof properties.$device_type === "string" && /^(Desktop|Mobile|Tablet)$/.test(properties.$device_type)) output.$device_type = properties.$device_type;
    if (typeof config.token === "string" && properties.token === config.token) output.token = properties.token;
    if (typeof output.distinct_id === "string" && properties.$device_id === output.distinct_id) output.$device_id = properties.$device_id;
    if (properties.$process_person_profile === false) output.$process_person_profile = false;
    if (properties.$is_identified === false) output.$is_identified = false;
    if (typeof properties.$insert_id === "string" && /^[A-Za-z0-9_-]{8,64}$/.test(properties.$insert_id)) output.$insert_id = properties.$insert_id;
    if (typeof properties.$time === "number" && isFinite(properties.$time)) output.$time = properties.$time;
    if (properties.$lib === "web") output.$lib = "web";
    if (typeof properties.$lib_version === "string" && /^\d+\.\d+\.\d+$/.test(properties.$lib_version)) output.$lib_version = properties.$lib_version;
    return output;
  }

  function sanitizeExceptionText(value, limit) {
    return typeof value === "string" ? value.split("\n")[0].slice(0, limit) : "";
  }

  function sanitizeExceptionFrame(frame) {
    if (!frame || typeof frame !== "object") return null;
    var output = { platform: "web:javascript" };
    var filename = typeof frame.filename === "string" ? frame.filename : "";
    output.filename = /^https?:\/\//i.test(filename) ? sanitizeReplayUrl(filename) : sanitizeExceptionText(filename, 200);
    output.function = sanitizeExceptionText(frame.function, 200) || "?";
    output.in_app = frame.in_app === true;
    ["lineno", "colno"].forEach(function (key) {
      if (typeof frame[key] === "number" && isFinite(frame[key])) output[key] = frame[key];
    });
    if (typeof frame.chunk_id === "string" && /^[A-Za-z0-9._-]{1,64}$/.test(frame.chunk_id)) output.chunk_id = frame.chunk_id;
    return output;
  }

  function sanitizeException(properties) {
    properties = properties || {};
    var output = sanitize(properties);
    output.page_type = typeof config.pageType === "string" ? config.pageType : "other";
    output.path_class = safePathClass();
    output.$exception_level = typeof properties.$exception_level === "string" && /^[a-z]{3,10}$/.test(properties.$exception_level) ? properties.$exception_level : "error";
    output.$exception_list = (Array.isArray(properties.$exception_list) ? properties.$exception_list : []).slice(0, 5).map(function (item) {
      item = item && typeof item === "object" ? item : {};
      var mechanism = item.mechanism && typeof item.mechanism === "object" ? item.mechanism : {};
      var frames = item.stacktrace && Array.isArray(item.stacktrace.frames) ? item.stacktrace.frames : [];
      return {
        type: sanitizeExceptionText(item.type, 200) || "Error",
        value: sanitizeExceptionText(item.value, 500),
        mechanism: { handled: mechanism.handled === true, synthetic: mechanism.synthetic === true, type: sanitizeExceptionText(mechanism.type, 40) || "generic" },
        stacktrace: { type: "raw", frames: frames.slice(0, 50).map(sanitizeExceptionFrame).filter(Boolean) }
      };
    });
    return output;
  }

  function sanitizeReplayUrl(value) {
    if (typeof value === "string" && /^(?:data|blob):/i.test(value)) return value;
    try {
      var url = new URL(value, location.origin);
      return url.origin + url.pathname;
    } catch (_) { return ""; }
  }

  function sanitizeReplayValue(value, key) {
    if (!value || typeof value !== "object") {
      return typeof value === "string" && /(?:url|href|src|action|referrer)/i.test(key || "") ? sanitizeReplayUrl(value) : value;
    }
    if (Array.isArray(value)) return value.map(function (item) { return sanitizeReplayValue(item, key); });
    Object.keys(value).forEach(function (childKey) {
      if (key === "attributes") {
        value[childKey] = sanitizeReplayAttribute(childKey, value[childKey]);
      } else {
        value[childKey] = sanitizeReplayValue(value[childKey], childKey);
      }
    });
    return value;
  }

  function sanitizeCapturedRequest(request) {
    if (!request || typeof request !== "object") return request;
    if (typeof request.name === "string") request.name = sanitizeReplayUrl(request.name);
    delete request.requestBody;
    delete request.responseBody;
    delete request.requestHeaders;
    delete request.responseHeaders;
    return request;
  }

  function sanitizeReplayAttribute(name, value) {
    if (/^(?:href|src|action|formaction|poster|background|xlink:href)$/i.test(name)) return sanitizeReplayUrl(value);
    if (/^srcset$/i.test(name) && typeof value === "string") return value.split(",").map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      parts[0] = sanitizeReplayUrl(parts[0]);
      return parts.join(" ");
    }).join(", ");
    if (/^style$/i.test(name) && typeof value === "string") return value.replace(/url\(\s*(["']?)([^"')]+)\1\s*\)/gi, function (_, quote, url) {
      return "url(" + quote + sanitizeReplayUrl(url) + quote + ")";
    });
    if (/^(?:value|rr_src)$/i.test(name) && typeof value === "string" && !/^data:/i.test(value) && /[?#]/.test(value) && /^(?:[a-z][a-z\d+.-]*:|\/\/|\/|\.\.?(?:\/|$))/i.test(value)) return sanitizeReplayUrl(value);
    return value;
  }

  function sanitizeSnapshotProperties(properties) {
    properties = properties || {};
    var output = { $snapshot_data: sanitizeReplayValue(properties.$snapshot_data, "$snapshot_data") };
    ["distinct_id", "$device_id", "$session_id", "$window_id", "$lib", "$lib_version", "$config_defaults", "$insert_id"].forEach(function (key) {
      if (typeof properties[key] === "string" && properties[key].length <= 200) output[key] = properties[key];
    });
    ["$time", "$lib_rate_limit_remaining_tokens", "$replay_sample_rate"].forEach(function (key) {
      if (typeof properties[key] === "number" && isFinite(properties[key])) output[key] = properties[key];
    });
    if (properties.$session_is_sampled === true) output.$session_is_sampled = true;
    if (properties.$geoip_disable === true) output.$geoip_disable = true;
    if (properties.$ip === null) output.$ip = null;
    if (typeof config.token === "string" && properties.token === config.token) output.token = properties.token;
    ["$current_url", "$referrer", "$initial_current_url"].forEach(function (key) {
      if (typeof properties[key] === "string") output[key] = sanitizeReplayUrl(properties[key]);
    });
    if (typeof properties.$pathname === "string" && properties.$pathname.charAt(0) === "/") output.$pathname = properties.$pathname;
    if (typeof properties.$host === "string" && properties.$host === location.hostname) output.$host = properties.$host;
    return output;
  }

  function replaySampled() {
    try {
      var sessionId = window.posthog && window.posthog.get_session_id();
      return typeof sessionId === "string" && sessionId.length > 0 && window.posthog.get_property("$session_is_sampled") === sessionId;
    } catch (_) { return false; }
  }

  function beforeSend(event) {
    if (!analyticsAllowed(activePrivacy)) { clearOwnCookies(); return null; }
    if (event && event.event === "$snapshot" && replaySampled()) {
      event.properties = sanitizeSnapshotProperties(event.properties);
      return event;
    }
    if (event && event.event === "$exception") {
      event.properties = sanitizeException(event.properties);
      return event;
    }
    if (!event || !allowedEvents.has(event.event)) return null;
    event.properties = sanitize(event.properties);
    return event;
  }

  function sampled(id) {
    var hash = 2166136261;
    for (var i = 0; i < id.length; i += 1) hash = Math.imul(hash ^ id.charCodeAt(i), 16777619);
    return (hash >>> 0) % 10 === 0;
  }

  function capture(name, properties) {
    if (!started || !allowedEvents.has(name)) return;
    window.posthog.capture(name, sanitize(properties));
  }

  function clearOwnCookies() {
    document.cookie = cookieName + "=; Max-Age=0; Path=/; SameSite=Lax; Secure";
    if (typeof config.token !== "string" || !config.token) return;
    var sdkCookieName = "ph_" + config.token + "_posthog";
    ["", "; Domain=" + location.hostname, "; Domain=." + location.hostname].forEach(function (domain) {
      document.cookie = sdkCookieName + "=; Max-Age=0; Path=/; SameSite=Lax; Secure" + domain;
    });
  }

  function ensureAvadaReopen() {
    if (!document.body) return;
    // A way to re-open the consent must exist on every page. Either Avada's own floating icon
    // (`.Avada-CookiesBar__ReopenButton`, switched off in the app since 2026-09-16) or the theme's
    // footer entry (`.Avada-CookieBar__PreferenceOpen` in sections/footer.liquid) counts; the
    // floating fallback below is only for a page that has neither.
    var nativeTrigger = document.querySelector(
      ".Avada-CookiesBar__ReopenButton:not([data-ss-avada-fallback]), .Avada-CookieBar__PreferenceOpen"
    );
    var fallback = document.querySelector("[data-ss-avada-fallback]");
    if (nativeTrigger) {
      if (fallback) fallback.remove();
      return;
    }
    if (fallback) return;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "Avada-CookiesBar__ReopenButton";
    button.setAttribute("data-ss-avada-fallback", "");
    button.setAttribute("aria-label", "Cookie-Einstellungen öffnen");
    button.title = "Cookie-Einstellungen öffnen";
    button.textContent = "🍪 Cookie-Einstellungen";
    button.style.cssText = "position:fixed;left:12px;bottom:12px;z-index:2147483000;padding:8px 10px;border:1px solid #2c332f;border-radius:999px;background:#fff;color:#2c332f;font:600 12px/1.2 Helvetica,Arial,sans-serif;box-shadow:0 2px 8px rgba(0,0,0,.2);cursor:pointer";
    document.body.appendChild(button);
  }

  function watchAvadaReopen() {
    if (avadaWatching) return;
    avadaWatching = true;
    var checks = 0;
    (function check() {
      ensureAvadaReopen();
      checks += 1;
      if (checks < 20) setTimeout(check, 500);
    }());
  }

  function revoke() {
    consentGeneration += 1;
    if (window.posthog) {
      window.posthog.stopSessionRecording && window.posthog.stopSessionRecording();
      window.posthog.opt_out_capturing && window.posthog.opt_out_capturing();
      window.posthog.reset && window.posthog.reset(true);
    }
    clearOwnCookies();
    started = false;
    loading = false;
  }

  function bindEvents() {
    if (bound) return;
    bound = true;
    capture("page_viewed", { page_type: config.pageType || "other", path_class: safePathClass() });
    if (config.productId) capture("product_viewed", {
      product_id: String(config.productId), variant_id: config.variantId ? String(config.variantId) : undefined,
      price: config.price, currency: config.currency
    });
    document.addEventListener("pointerdown", function (event) {
      if (!openingSent && event.target.closest(configuratorSelectors)) {
        openingSent = true; capture("configurator_opened", { product_id: String(config.productId || "") });
      }
    }, { passive: true });
    document.addEventListener("change", function (event) {
      if (!event.target.closest(configuratorSelectors)) return;
      clearTimeout(changeTimer);
      changeTimer = setTimeout(function () {
        capture("configuration_changed", { product_id: String(config.productId || ""), configuration_category: event.target.dataset.analyticsCategory || event.target.type || "control" });
      }, 250);
    });
    document.addEventListener("focusin", function (event) {
      if (event.target && event.target.matches && event.target.matches("[data-cfg-errors]") && event.target.textContent) {
        capture("configurator_validation_error", { product_id: String(config.productId || ""), error_code: "validation_blocked" });
      }
    });
    document.addEventListener("cfg:add_to_cart", function (event) {
      var detail = event.detail || {};
      var variant = document.querySelector("form[action*='/cart/add'] [name='id']");
      capture("product_added_to_cart", { product_id: String(config.productId || ""), variant_id: String(variant && variant.value || config.variantId || ""), price: typeof detail.applied_minor === "number" ? detail.applied_minor / 100 : undefined, currency: config.currency, quantity: detail.quantity });
    });
  }

  function start(privacy) {
    if (started || loading || !analyticsAllowed(privacy) || !config.token) return;
    loading = true;
    var generation = consentGeneration;
    var attempts = 0;
    (function waitForBridge() {
      if (generation !== consentGeneration || !analyticsAllowed(privacy)) { loading = false; return; }
      var id = bridgeId();
      if (!id) {
        attempts += 1;
        if (attempts < 20) return setTimeout(waitForBridge, 250);
        loading = false;
        if (config.debug) console.debug("PostHog skipped: Shopify client bridge unavailable");
        return;
      }
      var replay = true;
      var script = document.createElement("script");
      script.src = config.host + "/static/array.js";
      script.defer = true;
      script.onload = function () {
        if (generation !== consentGeneration || !analyticsAllowed(privacy)) { loading = false; return; }
        window.posthog.init(config.token, {
          api_host: config.host, ui_host: config.host, persistence: "cookie", person_profiles: "never",
          cookie_expiration: 30,
          request_batching: false,
          bootstrap: { distinctID: "shopify:" + id, isIdentifiedID: false }, autocapture: false,
          capture_pageview: false, capture_pageleave: false, capture_performance: false,
          capture_exceptions: { capture_unhandled_errors: true, capture_unhandled_rejections: true, capture_console_errors: false },
          capture_heatmaps: false, disable_surveys: true,
          enable_recording_console_log: false,
          advanced_disable_decide: !replay, advanced_disable_feature_flags: true,
          save_campaign_params: false, save_referrer: false, disable_scroll_properties: true,
          ip: false, before_send: beforeSend, disable_session_recording: !replay,
          session_recording: {
            maskAllInputs: false, maskInputOptions: { password: true }, blockSelector: blockedSelectors,
            maskAttributeFn: sanitizeReplayAttribute,
            recordCanvas: true, canvasFps: 1, canvasQuality: "0.3",
            recordHeaders: false, recordBody: false, maskCapturedNetworkRequestFn: sanitizeCapturedRequest
          }
        });
        window.posthog.opt_in_capturing && window.posthog.opt_in_capturing();
        started = true;
        loading = false;
        if (replay && window.posthog.startSessionRecording) window.posthog.startSessionRecording();
        bindEvents();
      };
      document.head.appendChild(script);
    }());
  }

  function boot() {
    setTimeout(watchAvadaReopen, 1500);
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
      if (error || !Shopify.customerPrivacy) return;
      var privacy = Shopify.customerPrivacy;
      activePrivacy = privacy;
      if (analyticsAllowed(privacy)) start(privacy); else clearOwnCookies();
      document.addEventListener("visitorConsentCollected", function () {
        if (analyticsAllowed(privacy)) start(privacy); else revoke();
      });
    });
  }

  if (window.__SS_POSTHOG_TEST__) window.__SS_POSTHOG_TEST_API__ = { analyticsAllowed: analyticsAllowed, beforeSend: beforeSend, bindEvents: bindEvents, bridgeId: bridgeId, ensureAvadaReopen: ensureAvadaReopen, sampled: sampled, sanitize: sanitize, sanitizeException: sanitizeException, sanitizeCapturedRequest: sanitizeCapturedRequest, sanitizeReplayAttribute: sanitizeReplayAttribute, sanitizeReplayValue: sanitizeReplayValue, blockedSelectors: blockedSelectors, revoke: revoke, start: start };
  boot();
}());
